import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import base from './request/api/base'
const env = base.backend
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    userdetail: localStorage.getItem('userdetail') || {},
    sidebar:true,
    isModalShow:false,
    brand:''
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, token, user, userdetail){
      state.status = 'success'
      state.token = token
      state.user = user
      state.userdetail = userdetail
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.userdetail = {}
    },
    sidebar(state){
      state.sidebar = !state.sidebar
    },
    showmodal(state){
      state.isModalShow = true
    },
    select_brand(state,brand_selected){
      state.brand = brand_selected
    }
  },
  actions: {
    login({commit}, code){
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios({url: `${env}/api/callback/`, data: code, method: 'POST' })
          .then(resp => {
            const token = resp.data.token
            const id_token = resp.data.id_token
            const userdetail = resp.data.userdetail
            localStorage.setItem('token', token)
            localStorage.setItem('id_token', id_token)
            localStorage.setItem('userdetail', JSON.stringify(userdetail))
            localStorage.setItem('brand_code',userdetail['brand_list'][0][0])
            localStorage.setItem('brand_name',userdetail['brand_list'][0][1])
            // console.log(localStorage.getItem('userdetail'))
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token, id_token,userdetail)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('id_token')
            localStorage.removeItem('userdetail')
            reject(err)
          })
        })
    },
    logout({commit}){
        return new Promise((resolve) => {
          commit('logout')
          localStorage.removeItem('token')
          localStorage.removeItem('id_token')
          localStorage.removeItem('userdetail')
          localStorage.removeItem('brand_code')
          localStorage.removeItem('brand_name')
          delete axios.defaults.headers.common['Authorization']
          resolve()
        })
      },
      sidebar({commit}){
          commit('sidebar')
      },
      showmodal({commit}){
        commit('showmodal')
      },
      select_brand({commit},brand_selected){
        commit('select_brand',brand_selected)
        localStorage.setItem('brand_code',brand_selected[0])
        localStorage.setItem('brand_name',brand_selected[1])
      }
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  }
})
